import { resetPanel, resetSection } from 'weblite-router'
import { RoomAppBarInfo } from '$common/room-app-bar/room-app-bar-info'
import { getPrivateSpace } from '$logic/private-space'
import { openSharedMedia } from '$logic/router'
import { t } from '$i18n'

export function PrivateSpaceAppBar() {
  const onSharedMedia = async () => {
    const { roomId } = getPrivateSpace()
    openSharedMedia(roomId)
    analite('CHAT_SHARED_MEDIA_CLICK', { type: 'PRIVATE_SPACE' })
  }

  return (
    <RoomAppBarInfo
      onClick={async () => {
        resetSection('right')
        resetPanel('roomProfile')

        onSharedMedia()
      }}
      avatarSrc="assets/svg/private-space.svg"
      primaryText={t('myAccount.savedMessage')}
      callElement={null}
    />
  )
}
